import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import { fetchSingleLineup } from "../../fetch/graphql/requests/lineups";
import { singleTopicLineup } from "../../fetch/graphql/queries/allContentItems";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import { receive_content } from "../../reducers/Content/reducer";
import { STATUS_CODES } from "../../actions/Content/constants";
import { DEFAULT_PAGE_SIZE } from "../../constants/content";
import { ERROR_TYPES } from "../../actions/Errors/constants";
import { insertAd } from "../../actions/Content/utils";
import log from "../../utils/logger/library";

/**
 * FETCH TOPIC
 * Fetches the JSON for the given TOPIC
 * Calls singleTopicLineup query which excludes type Sponsor Content
 * @param {string} section The section of the topic page, e.g. news/Location/Toronto
 * @returns {void}
 */

export const fetch_topic_gql = ({
    section,
    kind,
    keywords,
    page = 1,
    pageSize = DEFAULT_PAGE_SIZE,
    maybeInsertAd = false,
}) => {
    return async (dispatch, getState) => {
        if (!kind || !keywords) {
            return;
        }
        const currentContentList = getState().content.list;

        try {
            dispatch(start_loading());
            const timestamp = Date.now();

            const query = {
                page,
                pageSize,
                query: singleTopicLineup,
            };

            if (kind === "Subject") {
                query.concepts = decodeURIComponent(keywords);
            } else {
                query.tags = `${
                    kind === "Tag" ? "generic" : kind.toLowerCase()
                }:${decodeURIComponent(keywords)}`;
            }

            const { allContentItems } = await fetchSingleLineup(query);

            if (maybeInsertAd) {
                allContentItems.nodes = insertAd(allContentItems.nodes);
            }

            let contentList = [];

            contentList = currentContentList.concat(
                transformAllContentItems(allContentItems.nodes)
            );

            const firstItem = contentList[0];
            const contentPackage =
                firstItem && firstItem.packageComponents ? firstItem : null;

            dispatch(
                receive_content({
                    section,
                    contentList,
                    timestamp,
                    contentPackage,
                    pageValue: page,
                    status: STATUS_CODES.SUCCESS,
                    hasNextPage: allContentItems.nodes.length === pageSize,
                })
            );
        } catch (error) {
            // TODO: separate loadMore fetch from main content fetch
            if (page === 1) {
                // initData will handle the error and set the app state accordingly
                throw error;
            } else {
                // receive empty content, and hide the load more button
                dispatch(
                    receive_content({
                        contentList: currentContentList,
                        pageValue: page - 1,
                        section,
                        timestamp: Date.now(),
                        status: STATUS_CODES.CONTENT_TYPE_NOT_AVAILABLE,
                        hasNextPage: false,
                    })
                );
                const logMessage = `Error: {code: ${ERROR_TYPES.INVALID_CONTENT_REQUEST}, description: Content does not exist for keyword: ${keywords}}`;
                log.error(`(fetch_topic_gql) ${logMessage}`);
            }
        } finally {
            dispatch(set_loading_complete());
        }
    };
};

export const fetch_topic_load_more = (kind, keywords) => {
    const constantProps = {
        kind,
        keywords,
        maybeInsertAd: true,
    };
    return (fetchProps) => fetch_topic_gql({ ...constantProps, ...fetchProps });
};
